import { useTranslation } from 'react-i18next';

import { FlexGap, Label, LanguageSelect, tokens } from '@treams/treams-ui';

export default function UserSettingsLanguage() {
	const { t } = useTranslation();

	return (
		<FlexGap flexDirection="column" alignItems="flex-start" gap={tokens.gap.list}>
			<Label>{t('common.language.title')}</Label>
			<LanguageSelect.Synced />
		</FlexGap>
	);
}
